// extracted by mini-css-extract-plugin
module.exports = {"Container":"styles_Container__XGN1v","ImageContainer":"styles_ImageContainer__PYcdt","Inputfile":"styles_Inputfile__2xS2J","Button":"styles_Button__kCB9w"};